"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerBySportDataDtoGenderEnum = void 0;
exports.instanceOfPlayerBySportDataDto = instanceOfPlayerBySportDataDto;
exports.PlayerBySportDataDtoFromJSON = PlayerBySportDataDtoFromJSON;
exports.PlayerBySportDataDtoFromJSONTyped = PlayerBySportDataDtoFromJSONTyped;
exports.PlayerBySportDataDtoToJSON = PlayerBySportDataDtoToJSON;
exports.PlayerBySportDataDtoToJSONTyped = PlayerBySportDataDtoToJSONTyped;
/**
 * @export
 */
exports.PlayerBySportDataDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
};
/**
 * Check if a given object implements the PlayerBySportDataDto interface.
 */
function instanceOfPlayerBySportDataDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('slug' in value) || value['slug'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('nationality' in value) || value['nationality'] === undefined)
        return false;
    if (!('gender' in value) || value['gender'] === undefined)
        return false;
    if (!('dataSource' in value) || value['dataSource'] === undefined)
        return false;
    if (!('isSeeded' in value) || value['isSeeded'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
function PlayerBySportDataDtoFromJSON(json) {
    return PlayerBySportDataDtoFromJSONTyped(json, false);
}
function PlayerBySportDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'slug': json['slug'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'nationality': json['nationality'],
        'gender': json['gender'],
        'birthDate': json['birthDate'] == null ? undefined : json['birthDate'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'dataSource': json['dataSource'],
        'isSeeded': json['isSeeded'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function PlayerBySportDataDtoToJSON(json) {
    return PlayerBySportDataDtoToJSONTyped(json, false);
}
function PlayerBySportDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'slug': value['slug'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'displayName': value['displayName'],
        'teamId': value['teamId'],
        'nationality': value['nationality'],
        'gender': value['gender'],
        'birthDate': value['birthDate'],
        'imageUrl': value['imageUrl'],
        'externalId': value['externalId'],
        'dataSource': value['dataSource'],
        'isSeeded': value['isSeeded'],
        'metadata': value['metadata'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}
